<script setup lang="ts">
import ValueOverTimeChart from '../components/value-over-time-chart.vue'

interface CachedMetricPoint {
  metric_type: string
  frequency: string
  period_date: string
  value_amount: number
  currency: string
  computed_at: string
}

const monthlyCache: CachedMetricPoint[] = [
  { period_date: '2024-01-01', value_amount: 1_000_000 },
  { period_date: '2024-02-01', value_amount: 1_000_000 },
  { period_date: '2024-03-01', value_amount: 1_000_000 },
  { period_date: '2024-04-01', value_amount: 1_250_000 },
  { period_date: '2024-05-01', value_amount: 1_250_000 },
  { period_date: '2024-06-01', value_amount: 1_310_000 },
  { period_date: '2024-07-01', value_amount: 1_310_000 },
  { period_date: '2024-08-01', value_amount: 1_310_000 },
  { period_date: '2024-09-01', value_amount: 1_480_000 },
  { period_date: '2024-10-01', value_amount: 1_480_000 },
  { period_date: '2024-11-01', value_amount: 1_625_000 },
  { period_date: '2024-12-01', value_amount: 1_625_000 },
  { period_date: '2025-01-01', value_amount: 1_700_000 },
  { period_date: '2025-02-01', value_amount: 1_700_000 },
  { period_date: '2025-03-01', value_amount: 1_910_000 },
  { period_date: '2025-04-01', value_amount: 1_910_000 },
  { period_date: '2025-05-01', value_amount: 2_050_000 },
  { period_date: '2025-06-01', value_amount: 2_180_000 },
].map((p) => ({
  ...p,
  metric_type: 'current_value',
  frequency: 'monthly',
  currency: 'USD',
  computed_at: '2025-06-01T00:00:00Z',
}))
</script>

<template>
  <div class="mx-auto max-w-4xl p-6">
    <div class="mb-1 text-xs font-medium uppercase tracking-wide text-gray-400">Ticket #2244 · Phase 1 spike</div>
    <div class="rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
      <h2 class="mb-2 text-sm font-bold uppercase tracking-widest text-slate-500">Current value over time</h2>
      <ValueOverTimeChart :points="monthlyCache" currency="USD" />
    </div>
  </div>
</template>
